module.exports = __webpack_public_path__ + "static/media/1992.d568b660.svg";